// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.formLayout.k-form {
  color: #061c3f;
  padding: 0;
  width: 100%;
  max-width: 913px;
}
.formLayout.k-form fieldset {
  width: 100%;
  margin-bottom: 0;
}
.formLayout.k-form .error {
  position: relative;
  padding: 0 10%;
}
.formLayout.k-form .sendButton {
  margin: 25px auto;
  width: 168px;
}
.formLayout.k-form .sendButton.hidden {
  display: none;
}
.formLayout.k-form .sendButton .imgWrapper {
  display: inline-block;
  vertical-align: middle;
  margin-left: 15px;
}
.formLayout.k-form .sendButton .imgWrapper img {
  float: left;
}
.formLayout.k-form .k-form-field {
  width: 318px;
  float: none;
  margin: 20px auto;
}
.formLayout.k-form .k-form-field .k-textbox {
  width: 100%;
}
.formLayout.k-form .k-form-field .error {
  padding: 0;
  margin: 0;
}
.formLayout.k-form .breadcrumbContainer {
  text-align: center;
}
.formLayout.k-form .breadcrumbContainer .breadcrumb {
  display: inline-block;
  width: 100%;
  max-width: 596px;
  margin: 15px 0;
  text-align: center;
  float: none;
}
`, "",{"version":3,"sources":["webpack://./src/appComponents/common/FormView.less"],"names":[],"mappings":"AAGA;EACC,cAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;AAFD;AAFA;EAOE,WAAA;EACA,gBAAA;AAFF;AANA;EAYE,kBAAA;EACA,cAAA;AAHF;AAVA;EAiBE,iBAAA;EACA,YAAA;AAJF;AAME;EACC,aAAA;AAJH;AAjBA;EAyBG,qBAAA;EACA,sBAAA;EACA,iBAAA;AALH;AAtBA;EA8BI,WAAA;AALJ;AAzBA;EAoCE,YAAA;EACA,WAAA;EACA,iBAAA;AARF;AA9BA;EAyCG,WAAA;AARH;AAjCA;EA4CG,UAAA;EACA,SAAA;AARH;AArCA;EAkDE,kBAAA;AAVF;AAxCA;EAqDG,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;AAVH","sourcesContent":["@import (reference) '../constants.less';\n@import (reference) '../../commonComponents/forms/Form.less';\n\n.formLayout.k-form {\n\tcolor: @nightBlue;\n\tpadding: 0;\n\twidth: 100%;\n\tmax-width: @bodyWidth;\n\n\tfieldset {\n\t\twidth: 100%;\n\t\tmargin-bottom: 0;\n\t}\n\n\t.error {\n\t\tposition: relative;\n\t\tpadding: 0 10%;\n\t}\n\n\t.sendButton {\n\t\tmargin: @formButtonVerticalMargin auto;\n\t\twidth: 168px;\n\n\t\t&.hidden {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t.imgWrapper {\n\t\t\tdisplay: inline-block;\n\t\t\tvertical-align: middle;\n\t\t\tmargin-left: 15px;\n\n\t\t\timg {\n\t\t\t\tfloat: left;\n\t\t\t}\n\t\t}\n\t}\n\n\t.k-form-field {\n\t\twidth: @formFieldWidth;\n\t\tfloat: none;\n\t\tmargin: 20px auto;\n\n\t\t.k-textbox {\n\t\t\twidth: 100%;\n\t\t}\n\t\t.error {\n\t\t\tpadding: 0;\n\t\t\tmargin: 0;\n\t\t}\n\t}\n\n\t.breadcrumbContainer {\n\t\ttext-align: center;\n\n\t\t.breadcrumb {\n\t\t\tdisplay: inline-block;\n\t\t\twidth: 100%;\n\t\t\tmax-width: 596px;\n\t\t\tmargin: 15px 0;\n\t\t\ttext-align: center;\n\t\t\tfloat: none;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
